// Vue
import {mixins} from 'vue-class-component'
import {Component, Prop, Watch} from 'vue-property-decorator'
// Template
import template from './template.vue'
// Components
import {Button} from './../button/Button'
import {EventBus} from "../../../mixins/event_bus/EventBus";

@Component({
    name: 'Modal',
    components: {
        Button,
    },
    mixins: [
        template,
    ]
})
export class Modal extends mixins(EventBus) {

    public get modalClass() {
        return `${this.$appPrefix}-modal--${this.size}`
    }

    @Prop()
    public visible!: boolean

    @Prop({default: true})
    public closeable!: boolean

    @Prop()
    public title?: string

    @Prop({default: 'md'})
    public size!: string

    // ==================================
    // Types
    // ==================================
    public $refs!: {
        modal: any
    }

    @Watch('visible')
    public onVisibleChange() {
        if (this.visible) {
            this.$nextTick(() => {
                this.broadcastAll('Modal.opened', [])
            })
        } else {
            this.$nextTick(() => {
                this.broadcastAll('Modal.closed', [])
            })
        }
    }

    public created () {
        document.addEventListener('keydown', this.handleEscapeKey)
    }

    public destroyed() {
        document.removeEventListener('keydown', this.handleEscapeKey)
    }

    public handleModalClose(e: any) {
        if (e.target.contains(this.$refs.modal)) {
            this.handleClose()
        }
    }

    public handleClose() {
        
        if (!this.closeable) return

        this.$emit('update:visible', false)
        this.$emit('close')
    }

    private handleEscapeKey(e: KeyboardEvent) {
        
        if (!this.closeable) return

        if (this.visible && (e.key == 'Escape' || e.key == 'Esc' || e.keyCode == 27)) {
            this.handleClose()
        }
    }
}